const BTN_RIGHTS = 'BTN_RIGHTS'

export  function get_type (){
    return localStorage.getItem(BTN_RIGHTS)
}

export  function set_type (value){
    localStorage.setItem(BTN_RIGHTS,value)
}

export  function delete_type (){
    localStorage.removeItem(BTN_RIGHTS)
}
